module.exports = __webpack_public_path__ + "static/media/Assignment Cover Page.7038449f.pdf";